const s = {
  name: "NigerianNaira",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M16.9,11H15v6h-2v2h2v2h-2v2h2v6h2v-6h3.3l2.8,6H25v-6h2v-2h-2v-2h2v-2h-2v-6h-2v6h-3.3L16.9,11z M23,21h-1.4
			l-0.9-2H23V21z M22.5,23H23v1L22.5,23z M19.4,21H17v-2h1.5L19.4,21z M17.5,17H17v-1.1L17.5,17z"/>
		<path class="st0" d="M20,0C9,0,0,9,0,20s9,20,20,20c11,0,20-9,20-20S31.1,0,20,0z M2,20c0-9.9,8.1-18,18-18c9.9,0,18,8.1,18,18
			s-8.1,18-18,18C10.1,38,2,29.9,2,20z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as NigerianNaira
};
